import React from "react";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";
import { CustomModal } from "./CustomModel/CustomModal";

// actions: [{ icon, label, onClick, danger }]
const ParticipantActionsModal = ({ isOpen, onClose, title, actions }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <CustomModal isOpen={isOpen} onClose={onClose} compact>
            <form className="modal-form">
                <div className="modal-sticky-header">
                    <h2><FeatherIcon icon="user" /> {title || t("Participant")}</h2>
                </div>
                <ul className="user-search-results">
                    {actions?.map((a, i) => (
                        <li key={i} onClick={() => { onClose(); a.onClick(); }} style={{ cursor: "pointer" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", color: a.danger ? "var(--bright-alarm)" : undefined }}>
                                {/* same resting icon color as the header's own dots-menu
                                    (.dots_menu_container .options-menu .option .feather) -
                                    color set directly on the icon (not just the wrapping
                                    div's text color) so it isn't just inherited default
                                    text color, and so it still wins over that even if a
                                    shared .feather rule is ever added for this list.
                                    iconText: a short text glyph (e.g. the schedule's own
                                    "-:-" score placeholder) instead of a Feather icon, for
                                    actions a stock icon doesn't read well for - sized to the
                                    same 16px box so it still lines up with the icon column. */}
                                {a.iconText
                                    ? <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "16px", fontSize: "13px", fontWeight: 600, color: a.danger ? "var(--bright-alarm)" : "var(--light-color)" }}>{a.iconText}</span>
                                    : <FeatherIcon icon={a.icon || "user"} size={16} color={a.danger ? "var(--bright-alarm)" : "var(--light-color)"} />
                                } {a.label}
                            </div>
                        </li>
                    ))}
                </ul>
            </form>
        </CustomModal>
    );
};

export default ParticipantActionsModal;
